import BaseService from "../BaseService";
import _ from "lodash";
function generateUUID() {
    return 'xxxxxxxx_xxxxxxxx'.replace(/[xy]/g, function (c) {
        const r = Math.random() * 16 | 0,
            v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
}

class AnalyticService extends BaseService {
    indentifyUser = async () => {
        var uuid = localStorage.getItem("al_user_id");
        if (!uuid) {
            uuid = generateUUID();
            localStorage.setItem("al_user_id", uuid);
        }
        var customer_id = localStorage.getItem("customer_id");
        return { uuid: uuid, customer_id: customer_id }

    }

    track = async (event) => {
        var user = await  this.indentifyUser();

        var data = await this._api.post("store/analytic/track", {user, event});
     return data;
    };











}
export default AnalyticService;
